import { useNavigate, useLocation } from 'react-router-dom'

// Icons
function HomeIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 11l9-7 9 7"/>
      <path d="M9 22V12h6v10"/>
    </svg>
  )
}

function CalIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <path d="M16 2v4M8 2v4M3 10h18"/>
    </svg>
  )
}

function AskIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10"/>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
      <path d="M12 17h.01"/>
    </svg>
  )
}

function WrenchIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M14.7 6.3a4 4 0 1 0-5.4 5.4l-7 7 2 2 7-7a4 4 0 0 0 5.4-5.4z"/>
    </svg>
  )
}

function UserIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20 21a8 8 0 1 0-16 0"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  )
}

export default function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()

  const getActiveTab = () => {
    const path = location.pathname
    if (path === '/') return 'home'
    if (path === '/scheduled') return 'scheduled'
    if (path === '/orders') return 'orders'
    if (path === '/profile') return 'profile'
    return 'home'
  }

  const active = getActiveTab()

  const handleNavigation = (path) => {
    navigate(path)
  }

  const NavItem = ({ path, icon, isActive }) => (
    <button 
      onClick={() => handleNavigation(path)} 
      className={`flex-1 flex items-center justify-center py-2 touch-manipulation ${
        isActive ? 'text-slate-900' : 'text-slate-400'
      }`}
    >
      {icon}
    </button>
  )

  const handleAskClick = () => {
    navigate('/ai-inspect')
  }

  return (
    <div className="fixed bottom-0 inset-x-0 h-16 bg-white flex z-30 safe-area-inset shadow-2xl">
      <NavItem 
        path="/" 
        icon={<HomeIcon />} 
        isActive={active === 'home'} 
      />
      <NavItem 
        path="/scheduled" 
        icon={<CalIcon />} 
        isActive={active === 'scheduled'} 
      />
      
      {/* Center AI Inspect Button - Can overflow nav height */}
      <div className="flex-1 flex items-center justify-center relative">
        <button 
          onClick={handleAskClick}
          className="touch-manipulation relative -top-3"
        >
          <span className="relative inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-900 text-white shadow-2xl">
            <span className="absolute inset-0 rounded-full animate-ping bg-slate-900 opacity-20"></span>
            <div className="relative flex flex-col items-center">
              <span className="text-xs font-bold">AI</span>
              <span className="text-xs font-medium -mt-0.5">Inspect</span>
            </div>
          </span>
        </button>
      </div>

      <NavItem 
        path="/orders" 
        icon={<WrenchIcon />} 
        isActive={active === 'orders'} 
      />
      <NavItem 
        path="/profile" 
        icon={<UserIcon />} 
        isActive={active === 'profile'} 
      />
    </div>
  )
}
